import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

export default function Tina_McLaughlin() {
    return (
        <div>
            <Container>
                <Row>
                    <Col>
                        <p className="mainFont" style={{fontSize: '1.5em'}}>Dr. Archer</p><hr />
                        <p className="mainFont" style={{fontSize: '1em'}}>
                        CARE Hawaii&#39;s President, Dr. Tina Archer brings extensive experience in the delivery of 
                        mental health services. Dr. Archer developed and managed Castle Medical Center&#39;s psychiatric 
                        and addictions inpatient and outpatient programs and managed the Bobby Benson Residential Treatment 
                        Program. Dr. Archer has extensive experience in developing and in attaining accreditation for 
                        inpatient, residential and outpatient treatment facilities and managing these programs.
                        
                        <br />
                        </p>
                    </Col>
                </Row>
            </Container>

        </div>
    )
}
